<div class="content">
    <p>
        Water samples are tested for the bacteria <i>enterococci</i>, in the laboratory. The colonies (cluster of bacteria growing together) are counted to estimate the number of bacteria in the water.
    </p>

    <div class="nsw-table nsw-table-responsive" [tabindex]="0">
        <table>            
            <thead>
                <tr>
                    <th>Water quality rating</th>
                    <th>cfu/100ml</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="pollutant-popup-quality">Good</td>
                    <td>&lt;41</td>
                </tr>
                <tr>
                    <td class="pollutant-popup-quality">Fair</td>
                    <td>41-200</td>
                </tr>
                <tr>
                    <td class="pollutant-popup-quality">Poor</td>
                    <td>201-500</td>
                </tr>
                <tr>
                    <td class="pollutant-popup-quality">Bad</td>
                    <td>&gt;500
                </tr>
            </tbody>
        </table>
    </div>

    

</div>